import React from 'react';
import './SuccessButton.css';

function SuccessButton(props) {
  return (
    <button data-testid="save-button" style={{ background: props.background,color:props.color }} disabled={props.disabled} className='EmpMasterBtn' onClick={props.onClick}>{props.children}</button>
  )
}

export default SuccessButton